import { render, staticRenderFns } from "./AllBootcamp.vue?vue&type=template&id=60dc15c9&scoped=true&"
import script from "./AllBootcamp.vue?vue&type=script&lang=js&"
export * from "./AllBootcamp.vue?vue&type=script&lang=js&"
import style0 from "./AllBootcamp.vue?vue&type=style&index=0&id=60dc15c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dc15c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
